import styled, { css } from 'styled-components';

export const cssFutura = css`
  font-family: futura-pt;
  font-weight: bold;
  font-style: oblique;
  letter-spacing: -1px;
`;

export const Futura = styled.i`
  ${cssFutura}
`;
